import React, { useState, useEffect } from 'react';
import { Container } from 'reactstrap';
import axios from '../../axios';
import * as url from '../../utils/url';
import { toastContainer } from '../../utils/toast';
import './start-chat.css';

const StartChat = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const phoneNumber = urlParams.get('phone') || '';
    const orgId = urlParams.get('orgId') || '';
    const hasPhone = phoneNumber.trim().length > 0;

    // Clean phone number for SMS link
    const cleanPhone = phoneNumber.replace(/\D/g, '');

    const [hashtags, setHashtags] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        axios.get(url.textifyListGroups, { params: { orgId: orgId, skip: 0 } })
            .then(function(res) {
                var items = (res.data && res.data.items) || [];
                var formatted = items.map(function(item) {
                    return {
                        id: item._id,
                        name: item.groupName && item.groupName.startsWith('#')
                            ? item.groupName.slice(1)
                            : (item.groupName || ''),
                        description: item.description || '',
                    };
                });
                setHashtags(formatted);
            })
            .catch(function(err) {
                console.error('[StartChat] Error loading hashtag groups:', err);
                setError('Unable to load hashtag groups.');
            })
            .finally(function() {
                setLoading(false);
            });
    }, []);

    const handleCopy = () => {
        navigator.clipboard.writeText(phoneNumber);
        toastContainer('Copied to clipboard', 'success');
    };

    return (
        <div className="start-chat-screen">
            <Container className="start-chat-container">
                <h1 className="start-chat-title">Start a chat via text</h1>
                {hasPhone ? (
                    <>
                        <p className="start-chat-subtitle">
                            Text <span className="highlight-phone">{phoneNumber}</span> to start your chat with<br />one of the below hashtags.
                        </p>
                        <a href={`sms:${cleanPhone}`} className="text-button">
                            Text {phoneNumber}
                        </a>
                        <button className="copy-button" onClick={handleCopy}>
                            Copy number
                        </button>
                    </>
                ) : (
                    <p className="start-chat-subtitle">
                        Scan the QR code or follow the link provided by your company to start a chat.
                    </p>
                )}

                <div className="hashtag-card-container">
                    <h2 className="hashtag-card-title">Choose a hashtag</h2>
                    <div className="hashtag-list">
                        {loading ? (
                            <div className="hashtag-loading">Loading...</div>
                        ) : error ? (
                            <div className="hashtag-error">{error}</div>
                        ) : hashtags.length === 0 ? (
                            <div className="hashtag-empty">No hashtag groups available.</div>
                        ) : (
                            hashtags.map((h) => (
                                <div key={h.id} className="hashtag-item">
                                    <div className="hashtag-name-wrapper">
                                        <span className="hashtag-symbol">#</span>
                                        <span className="hashtag-name">{h.name}</span>
                                    </div>
                                    {h.description && (
                                        <div className="hashtag-description">{h.description}</div>
                                    )}
                                </div>
                            ))
                        )}
                    </div>
                </div>

                <div className="start-chat-footer">
                    <p>Standard messaging rates may apply.</p>
                    <p>You'll receive a confirmation after your first message.</p>
                </div>
            </Container>
        </div>
    );
};

export default StartChat;
